<template>
  <div>
    <div>
      <!-----------------heading and buttons ---------------------->
      <v-row class="d-flex justify-space-between" flat>
        <v-col cols="12" class="d-flex align-center">
          <v-btn icon to="/DigitalManual" color="transparent" class="mr-2">
            <v-icon color="black"> mdi-keyboard-backspace</v-icon>
          </v-btn>
          <h1 class="heading-1">Archived Manuals</h1>
        </v-col>
      </v-row>
      <!----------------- search and filter ---------------------->
      <div class="my-3">
        <v-row class="mt-6">
          <v-col cols="12" xl="4">
            <v-card flat>
              <v-text-field
                dense
                outlined
                prepend-inner-icon="mdi-magnify"
                label="Search"
                v-model="search"
                hide-details
                single-line
              >
              </v-text-field>
            </v-card>
          </v-col>
        </v-row>
      </div>
      <!----------------- data table ---------------------->
      <v-card class="mt-6" outlined>
        <v-data-table
          :headers="headers"
          :loading="tableLoader"
          loading-text="Loading... Please wait"
          :items="GetDigitalManuals"
          :page.sync="page"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          item-key="Id"
          show-expand
          @page-count="pageCount = $event"
          :items-per-page="displayedItemsPerPage"
          hide-default-footer
        >
          <template v-slot:[`item.index`]="{ item }">
            <b> {{ item.Id }} </b>
          </template>

          <template v-slot:[`item.title`]="{ item }">
            <span class="table_style_one">
              <b> {{ item.Title }} </b></span
            >
          </template>
          <template v-slot:[`item.numberOfVersion`]="{ item }">
            <span class="table_style_two">
              {{ item.DigitalManualFile.length }}
            </span>
          </template>
          <template v-slot:[`item.numberOfLanguage`]="{ item }">
            <span class="table_style_two">
              {{ item.DigitalManualFile.length }}
            </span>
          </template>
          <template v-slot:[`item.CreatedDate`]="{ item }">
            <span class="table_style_two">{{
              checkDate(item.CreatedDate)
            }}</span>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu
              transition="scroll-y-transition"
              offset-y
              color="transparent"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon color="A1A1A6" v-bind="attrs" v-on="on" class="mx-3">
                  mdi-dots-horizontal
                </v-icon>
              </template>
              <v-card flat>
                <v-list class="px-3 pt-1" color="transparent">
                  <v-btn
                    depressed
                    color="transparent"
                    block
                    class="d-flex justify-start"
                    @click="GoToArchived(item)"
                  >
                    <v-icon color="#646464">mdi-archive-arrow-up</v-icon>
                    <span class="ml-4 text_style">UnArchive</span>
                  </v-btn>
                </v-list>
              </v-card>
            </v-menu>
          </template>
          <!-----------------Expanded data table ---------------------->
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div style="display: none">More info about {{ item.id }}</div>
              <v-card class="my-6" outlined v-show="item.Id">
                <v-data-table
                  :headers="headers2"
                  :loading="tableLoader"
                  loading-text="Loading... Please wait"
                  :items="item.DigitalManualFiles"
                  :page.sync="page"
                  item-key="Id"
                  @page-count="pageCount = $event"
                  hide-default-footer
                >
                  <template v-slot:[`item.index`]="{ item }">
                    <b> {{ item.Id }} </b>
                  </template>

                  <template v-slot:[`item.File`]="{ item }">
                    <span class="table_style_one">
                      {{ item.File.split("_")[1] }}
                    </span>
                  </template>
                  <template v-slot:[`item.Language`]="{ item }">
                    <span class="table_style_two">
                      {{ item.Language }}
                    </span>
                  </template>
                  <!-- <template v-slot:[`item.numberOfVersion`]="{ item }">
                    <span class="table_style_two">
                      {{ item.numberOfVersion }}
                    </span>
                  </template> -->
                  <template v-slot:[`item.CreatedDate`]="{ item }">
                    <span class="table_style_two">
                      {{ checkDate(item.CreatedDate) }}
                    </span>
                  </template>

                  <template v-slot:[`item.Id`]="{ item }">
                    <v-list class="px-3 pt-1" color="transparent">
                      <v-btn
                        @click="downloadFile(item.Id)"
                        depressed
                        color="transparent"
                        class="d-flex justify-start"
                      >
                        <v-icon color="#646464">mdi-tray-arrow-down</v-icon>
                      </v-btn>
                    </v-list>
                  </template>
                </v-data-table>
              </v-card>
            </td>
          </template>
        </v-data-table>
      </v-card>
      <v-card flat class="my-9 d-flex justify-end align-center">
        <span class="text_transform pa-0 ma-0">Per page : </span>
        <v-card flat width="100" class="mx-5">
          <v-select
            :items="ItemsPerPageItems"
            label="Items per page"
            v-model="itemsPerPage"
            @input="fetchData"
          ></v-select>
        </v-card>
        <v-pagination
          v-model="page"
          :length="pageCount"
          :total-visible="5"
          @input="fetchData"
        ></v-pagination
      ></v-card>
    </div>
    <!------------Update manual dialog-------------------------->
    <v-dialog v-model="UploadManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Upload Manual</b></span>
          <v-icon @click="UploadManualDialog = false">mdi-close</v-icon>
        </div>
        <UploadManualComponent
          :UploadManual="UploadManualDialog"
          @close="close"
        ></UploadManualComponent>
      </v-card>
    </v-dialog>
    <!------------Edit manual dialog-------------------------->
    <v-dialog v-model="EditManualDialog" persistent max-width="600">
      <v-card>
        <div class="mx-8 py-5 d-flex justify-space-between">
          <span class="heading-2"> <b> Edit Manual</b></span>
          <v-icon @click="EditManualDialog = false">mdi-close</v-icon>
        </div>
        <EditManualComponent
          :EditManual="EditManualDialog"
          @close="close"
        ></EditManualComponent>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import UploadManualComponent from "../../components/DigitalManual/UploadManual.component.vue";
import EditManualComponent from "../../components/DigitalManual/EditManual.component.vue";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  components: { UploadManualComponent, EditManualComponent },
  data() {
    return {
      LanguageArray: [
        "English",
        "French",
        "German",
        "Japanese",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      expanded: [],
      singleExpand: false,
      UploadManualDialog: false,
      EditManualDialog: false,
      filterDialog: false,
      ItemsPerPageItems: [10, 50, 100, 200, "All"],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      valid: false,
      dialog: false,
      isPlaying: false,
      editvideodialog: false,
      newcategorydialog: false,
      organizedialog: false,
      SeeProfileDialog: false,
      tableLoader: false, // data-table true or false for future
      add_dialog: false,
      btnloader: false,
      test: true,
      NameCategory: "",
      Language: "",
      search: "",
      searchTimer: 0,

      headers: [
        { text: "Title", value: "Title" },
        { text: "Last Updated", value: "CreatedDate" },
        { text: "", value: "actions", sortable: false },
      ],
      headers2: [
        { text: "Version #", value: "index", sortable: false },
        { text: "File Name", value: "File" },
        { text: "Language", value: "Language" },
        { text: "Upload Date", value: "CreatedDate" },
        { text: "", value: "Id", sortable: false },
      ],
      DataTableOne: [],
      DataTableTwo: [],
      Fitems: [],
      Fitems2: [],
    };
  },
  computed: {
    ...mapGetters(["GetDigitalManuals"]),
    displayedItemsPerPage() {
      return this.itemsPerPage === "All"
        ? this.GetDigitalManuals.length
        : this.itemsPerPage;
    },
  },
  mounted() {
    this.tableLoader = true;
    this.fetchData();
    this.tableLoader = false;
  },
  methods: {
    GoToArchived(item) {
      this.$store.dispatch("AddArchivedDigitalManula", item).then(() => {
        this.fetchData();
        this.$swal.fire({
          toast: true,
          position: "top-end",
          icon: "success",
          title: "Unarchive successfully",
          showConfirmButton: false,
          timer: 1500,
        });
      });
    },
    fetchData() {
      const obj = {
        page: this.page,
        pageSize: this.itemsPerPage,
        search: this.search,
      };
      this.tableLoader = true;
      this.$store.dispatch("GetDigitalArchiveManuals", obj).then((res) => {
        this.tableLoader = false;
        if (this.itemsPerPage != "All") {
          this.pageCount = Math.ceil(res.Data.totalRecords / this.itemsPerPage);
        } else {
          this.pageCount = 1;
        }
      });
    },
    close() {
      this.UploadManualDialog = false;
      this.EditManualDialog = false;
    },
    checkDate(x) {
      return moment(x).format("MM/DD/YY");
    },
    send() {
      setTimeout(() => {
        this.btnloader = true;
      }, 100);
      setTimeout(() => {
        this.organizedialog = false;
        this.btnloader = false;
        this.newcategorydialog = false;
        this.editvideodialog = false;
      }, 2000);
    },
    downloadFile(id) {
      let baseUrl = process.env.VUE_APP_IMG_URL;
      this.$store.dispatch("GetDownloadDigitalManualFile", id).then(() => {
        window.open(`${baseUrl + "file.zip"}`);
      });
    },
  },
  watch: {
    search() {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.fetchData();
      }, 700);
    },
  },
};
</script>
<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #e0e0e0;
}

.text_trans {
  text-transform: none;
}
</style>
